import React from 'react'
import {Redirect} from 'react-router-dom'
import EstateContext from 'components/shared/EstateLayout/EstateContext'
import {Desktop} from 'components/shared/Responsive'

const EstateDashboard = () => {
  return (
    <Desktop>
      <EstateContext.Consumer>
        {({estate, products}) => {
          const firstProduct = products[0]
          if (firstProduct) {
            return (
              <Redirect to={`/oppdrag/${estate.id}/produkt/${firstProduct.id}`} />
            )
          }
          return null
        }}
      </EstateContext.Consumer>
    </Desktop>
  )
}

export default EstateDashboard
